import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Iconify from "./Iconify";
import moment from "moment-timezone";
export default function CustomTimeline(props) {
  const data = props.data;

  const [steps, setSteps] = React.useState(() => {
    if (!data?.id) {
      return data?.steps || [];
    }

    try {
      const storedSteps = localStorage.getItem(`driver_steps_${data.id}`);

      return storedSteps ? JSON.parse(storedSteps) : data?.steps || [];
    } catch (error) {
      console.error("❌ Failed to read steps:", error);
      return data?.steps || [];
    }
  });

  React.useEffect(() => {
    if (!data?.id) return;

    const key = `driver_steps_${data.id}`;

    try {
      const storedSteps = localStorage.getItem(key);

      if (storedSteps) {
        setSteps(JSON.parse(storedSteps));
      } else {
        setSteps(data?.steps || []);
      }
    } catch (error) {
      console.error("❌ Failed to load steps:", error);
      setSteps(data?.steps || []);
    }
  }, [data?.id, data?.steps]);

  React.useEffect(() => {
    const handleStepsUpdate = (event) => {
      if (!data?.id) return;

      // Sirf isi driver ke updates lo
      if (String(event.detail?.driverId) !== String(data.id)) {
        return;
      }

      const newSteps = event.detail?.steps;

      if (Array.isArray(newSteps)) {
        console.log("🔥 Timeline received updated steps:", newSteps);

        setSteps(newSteps);
      }
    };

    window.addEventListener("driver-steps-updated", handleStepsUpdate);

    return () => {
      window.removeEventListener("driver-steps-updated", handleStepsUpdate);
    };
  }, [data?.id]);
  return (
    <Box
      style={{
        height: "424px",
        overflowY: "auto", // Enables vertical scrolling only
        overflowX: "hidden", // Hides horizontal scrollbar
        scrollbarWidth: "thin", // For Firefox, makes the scrollbar thinner
        scrollbarColor: "#888 #f1f1f1", // Customize scrollbar color for Firefox
      }}
    >
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        {steps?.map((val, index) => {
          return (
            <TimelineItem
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
              key={val.id}
            >
              <TimelineSeparator>
                <TimelineDot
                  style={{
                    height: 24,
                    width: 24,
                    marginBottom: 5,
                    borderWidth: 3,
                    backgroundColor: "#FFFFFF",
                    borderColor: val?.isCompleted == 1 ? "#ED1B24" : "grey",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 2,
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      borderColor: val?.isCompleted == 1 ? "#ED1B24" : "grey",
                      borderWidth: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      height: 25,
                      width: 25,
                      backgroundColor:
                        val?.isCompleted == 1 ? "#ED1B24" : "#FFFFFF",
                      borderRadius: 100,
                    }}
                  >
                    {val?.isCompleted == 1 ? (
                      <Iconify
                        style={{ fontSize: 18, color: "white" }}
                        icon="ic:round-check"
                      />
                    ) : (
                      <div style={{ height: 25, width: 25 }} />
                    )}
                  </Box>
                </TimelineDot>
                <TimelineConnector
                  sx={{
                    bgcolor: "transparent",
                    height: "auto",
                    width: 0,
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 0.3,
                  }}
                >
                  {data?.steps.length != index + 1 && (
                    <div
                      style={{
                        height: 50,
                        flex: 1,
                        border:
                          data?.steps[index + 1]?.isCompleted == 1
                            ? "2px dashed red"
                            : "2px dashed grey",
                      }}
                    />
                  )}
                </TimelineConnector>
              </TimelineSeparator>
              <TimelineContent
                style={{ height: 50, marginBottom: 10 }}
                sx={{ py: "10px", px: 2 }}
              >
                <Typography
                  variant={"body1"}
                  component="span"
                  style={{ fontWeight: 600 }}
                >
                  {val?.name}
                </Typography>

                <>
                  {val.updated_at && val?.isCompleted == 1 && (
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: {
                          xs: "0.55rem",
                          sm: "0.575rem",
                          md: "0.6rem",
                        },
                      }}
                    >
                      {moment
                        .utc(val?.updated_at)
                        .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                        .format("DD-MMM-YYYY h:mm A")}
                    </Typography>
                  )}

                  {val?.notes ? (
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: { xs: "250px", sm: "300px", lg: "300px" },
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            xs: "0.55rem",
                            sm: "0.575rem",
                            md: "0.6rem",
                          },
                          lineHeight: { xs: "1.3", sm: "1.3", md: "1.2" },
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          WebkitLineClamp: 2,
                          height: 24,
                        }}
                      >
                        {val?.notes}
                      </Typography>
                    </Box>
                  ) : (
                    <div style={{ height: 35 }} />
                  )}
                </>
              </TimelineContent>
            </TimelineItem>
          );
        })}
      </Timeline>
    </Box>
  );
}
